import { Suspense, useEffect } from 'react'
import { useParams } from 'react-router'
import { useDispatch } from 'react-redux'
import CommonFallback from '@/shared/components/CommonFallback'
import useOrganizationEditForm from './useOrganizationEditForm'
import useSaveOrganization from './useSaveOrganization'
import FieldSkeleton from '@/containers/SubscriptionFormPage/SubscriptionForm/FieldSkeleton'
import saveEnergyOrganization from './Energy/saveEnergyOrganization'
import saveTelecomOrganization from './Telecom/saveTelecomOrganization'
import saveInsuranceOrganization from './Insurance/saveInsuranceOrganization'
import useBusinessType from '@/shared/hooks/useBusinessType'
import { organizationsManagementActions } from '../organizationsManagementSagas'

const saveFnByType = {
  energie: saveEnergyOrganization,
  telecom: saveTelecomOrganization,
  assurance: saveInsuranceOrganization,
}

const Edit = () => {
  const { id } = useParams()
  const dispatch = useDispatch()
  const isEditMode = !!id
  const { type } = useBusinessType({
    loaderRoutesEnergy: {},
    loaderRoutes: {},
    loaderRoutesInsurance: {},
  })
  const { LocalizedModule } = useOrganizationEditForm()
  const { saveProvider, selectedProvider } = useSaveOrganization(saveFnByType[type], id)

  useEffect(() => {
    if (isEditMode && !selectedProvider.uuid) {
      dispatch({ type: organizationsManagementActions.LOAD_PROVIDER, providerId: id })
    }
  }, [id])

  if (isEditMode && !selectedProvider.uuid) {
    return <CommonFallback />
  }

  if (!LocalizedModule) {
    return
  }

  return (
    <Suspense fallback={<FieldSkeleton />}>
      <LocalizedModule saveProvider={saveProvider} />
    </Suspense>
  )
}

export default Edit
